import { render } from "./meeting_agenda.vue?vue&type=template&id=7c9accd0"
import script from "./meeting_agenda.vue?vue&type=script&lang=js"
export * from "./meeting_agenda.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\discussion-guru\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__